export const setModalOpenState = (payload: any) => ({ type: 'SET_MODAL_STATE', payload });
